
  <ion-card class="ion-no-margin mar8 card-white-background-color">
    <ion-row class="ion-text-center fs-3 card-flight" (click)="navigateToDetail(flight)">
    <ion-col size="3">
      <img
      class="airline-logo"
      [src]="flight?.col1_data1"
    />
    <ion-label class="display-blk fs-2 font600 card-primary-text-color">{{flight?.col1_data2}}</ion-label>
    </ion-col>
    <ion-col size="3">
      <ion-label class="fs-2 font600 card-primary-text-color">{{flight?.col2_data1}}</ion-label>
      <ion-label class="display-blk pt-10 fs-2 font500 card-primary-text-color">
     {{flight?.col2_data2}}
      </ion-label>
    </ion-col>
    <ion-col size="3">
      <ion-label class="fs-2 font600 card-primary-text-color">{{flight?.col3_data1}}</ion-label>
      <ion-label class="display-blk fs-2 font500 pt-10 card-primary-text-color">
        {{flight?.col3_data2}}
      </ion-label>
    </ion-col>
    <ion-col size="3">
  <ion-label class="fs-2 font600 card-green-text-color" *ngIf=" (flight?.col4)?.toLowerCase().trim() === 'on-time' ; else delayed ">{{flight?.col4}}</ion-label>
  <ng-template  #delayed>
    <ion-label class="fs-2 font600  card-yellow-text-color" *ngIf=" (flight?.col4)?.toLowerCase().trim() === 'delayed' ; else cancelled">{{flight?.col4}}</ion-label>
  </ng-template>
  <ng-template  #cancelled>
    <ion-label class="fs-2 font600 card-red-text-color" *ngIf=" (flight?.col4)?.toLowerCase().trim() === 'cancelled' ; else otherStatus">{{flight?.col4}}</ion-label>
  </ng-template>
  <ng-template #otherStatus>
   <ion-label class="fs-2 font600 card-primary-text-color">{{flight?.col4}}</ion-label>
  </ng-template>
    </ion-col>
  </ion-row>
    </ion-card>

